var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMaxLogo = function SvgMaxLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 69,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.372 43.214a8.673 8.673 0 01-5.272-1.786c-3.816-2.923-4.544-8.39-1.631-12.219L190.4 4.338a8.661 8.661 0 0112.175-1.637c3.816 2.923 4.544 8.39 1.632 12.219l-18.931 24.87a8.652 8.652 0 01-6.904 3.424z",
    fill: "url(#max-logo_svg__paint0_linear_1366_38919)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.317 68.085a8.65 8.65 0 01-6.904-3.423l-18.931-24.871c-2.912-3.83-2.184-9.296 1.632-12.22a8.662 8.662 0 0112.175 1.638L204.22 54.08c2.913 3.83 2.184 9.297-1.631 12.22a8.645 8.645 0 01-5.272 1.785z",
    fill: "url(#max-logo_svg__paint1_linear_1366_38919)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.193 38.316s.013-.027.027-.04c.013-.028.027-.055.04-.095a8.726 8.726 0 00.809-3.573v-.121-.109a8.77 8.77 0 00-.755-3.437c-.014-.04-.04-.08-.054-.108-.013-.027-.027-.068-.04-.095 0 0 0-.027-.014-.027a8.092 8.092 0 00-1.011-1.61L166.358 4.365a8.661 8.661 0 00-12.175-1.637c-3.816 2.923-4.544 8.39-1.632 12.219l11.61 15.25a7.168 7.168 0 010 8.66l-11.61 15.25c-2.912 3.83-2.184 9.297 1.632 12.22a8.643 8.643 0 005.272 1.786 8.649 8.649 0 006.903-3.424l18.837-24.736c.391-.5.728-1.042 1.011-1.596l-.013-.041z",
    fill: "url(#max-logo_svg__paint2_linear_1366_38919)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.343 68.085c-4.8 0-8.684-3.897-8.684-8.714V9.63C.66 4.812 4.542.915 9.343.915c4.8 0 8.683 3.897 8.683 8.714V59.37c0 4.817-3.883 8.714-8.683 8.714z",
    fill: "url(#max-logo_svg__paint3_linear_1366_38919)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.224 43.214a8.678 8.678 0 01-5.892-2.314c-3.52-3.26-3.748-8.782-.486-12.313L48.728 3.716c3.25-3.532 8.75-3.762 12.27-.488 3.52 3.262 3.748 8.782.486 12.314L38.602 40.413a8.67 8.67 0 01-6.378 2.801z",
    fill: "url(#max-logo_svg__paint4_linear_1366_38919)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.237 43.214a8.67 8.67 0 01-6.377-2.8L2.978 15.541c-3.25-3.531-3.034-9.052.486-12.314 3.519-3.26 9.02-3.044 12.27.488l22.881 24.87c3.25 3.532 3.034 9.053-.485 12.315a8.678 8.678 0 01-5.893 2.313z",
    fill: "url(#max-logo_svg__paint5_linear_1366_38919)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M.497 35.339a8.83 8.83 0 015.636-8.119 8.79 8.79 0 019.614 2.22L.66 9.641l-.162 25.71v-.013z",
    fill: "url(#max-logo_svg__paint6_linear_1366_38919)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.12 68.085c-4.801 0-8.684-3.897-8.684-8.714V9.63c0-4.817 3.883-8.714 8.683-8.714s8.684 3.897 8.684 8.714V59.37c0 4.817-3.884 8.714-8.684 8.714z",
    fill: "url(#max-logo_svg__paint7_linear_1366_38919)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.09 68.113a8.753 8.753 0 01-3.41-.704c-4.41-1.895-6.46-7.01-4.572-11.434l21.183-49.77c1.888-4.424 6.985-6.481 11.394-4.587 4.409 1.895 6.458 7.01 4.571 11.434l-21.183 49.77c-1.402 3.315-4.611 5.29-7.996 5.29h.014z",
    fill: "url(#max-logo_svg__paint8_linear_1366_38919)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.242 58.519h21.789c4.315 0 7.807-3.505 7.807-7.835s-3.492-7.835-7.807-7.835h-21.79c-4.314 0-7.806 3.505-7.806 7.835s3.492 7.835 7.807 7.835z",
    fill: "url(#max-logo_svg__paint9_linear_1366_38919)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M108.136 42.862l6.661 15.657h4.301l-6.714-15.657h-4.248z",
    fill: "url(#max-logo_svg__paint10_linear_1366_38919)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.47 68.113c1.132 0 2.292-.23 3.411-.704 4.409-1.895 6.459-7.01 4.571-11.434l-21.183-49.77c-1.887-4.424-6.984-6.481-11.393-4.587-4.41 1.895-6.459 7.01-4.571 11.434l21.182 49.77a8.665 8.665 0 007.996 5.29h-.013z",
    fill: "url(#max-logo_svg__paint11_linear_1366_38919)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.979 28.736a8.816 8.816 0 00-8.144-5.467 8.816 8.816 0 00-8.144 5.467l9.6-22.558h5.825l.863 22.544v.014z",
    fill: "url(#max-logo_svg__paint12_linear_1366_38919)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint0_linear_1366_38919",
    x1: 206.715,
    y1: 22.064,
    x2: 175.15,
    y2: 22.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint1_linear_1366_38919",
    x1: 206.715,
    y1: 46.936,
    x2: 175.15,
    y2: 46.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint2_linear_1366_38919",
    x1: 155.625,
    y1: 69.628,
    x2: 175.238,
    y2: -0.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint3_linear_1366_38919",
    x1: 7.064,
    y1: 62.402,
    x2: 10.472,
    y2: 21.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint4_linear_1366_38919",
    x1: 23.541,
    y1: 22.064,
    x2: 63.803,
    y2: 22.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint5_linear_1366_38919",
    x1: 2.965,
    y1: 0.536,
    x2: 35.001,
    y2: 38.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint6_linear_1366_38919",
    x1: -9.197,
    y1: 10.671,
    x2: 22.853,
    y2: 49.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint7_linear_1366_38919",
    x1: 60.971,
    y1: 65.244,
    x2: 47.109,
    y2: -7.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint8_linear_1366_38919",
    x1: 85.727,
    y1: 78.329,
    x2: 98.948,
    y2: 25.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint9_linear_1366_38919",
    x1: 126.838,
    y1: 50.684,
    x2: 89.435,
    y2: 50.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint10_linear_1366_38919",
    x1: 116.186,
    y1: 49.588,
    x2: 111.637,
    y2: 51.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint11_linear_1366_38919",
    x1: 101.799,
    y1: 63.701,
    x2: 129.903,
    y2: 12.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "max-logo_svg__paint12_linear_1366_38919",
    x1: 120.501,
    y1: 59.425,
    x2: 92.383,
    y2: 8.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFF"
  })))));
};
export default SvgMaxLogo;